<template>
  <base-dialog :showDialog="showDialog" :scrollable="true">
    <template v-slot:body>
      <v-card dark>
        <v-card-title>
          <span class="text-subtitle-1">{{ $t('titulos.selectHeaders') }}</span>
        </v-card-title>
        <v-card-text>
          <div v-for="(header, index) in headerList" :key="index">
            <v-checkbox
              v-model="header.show"
              :label="header.text"
              @input="handleInput"
              :disabled="header.value === 'controls' ? true : false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn small color="red" @click="saveHeader">
            <v-icon small left>mdi-close</v-icon>
            <span class="text-overline px-1">{{ $t('labels.voltar') }}</span>
          </v-btn>
          <v-spacer />
          <v-btn small color="info" @click="setAll">
            <v-icon small left>mdi-checkbox-marked-outline</v-icon>
            <span class="text-overline px-1">{{ $t('labels.tudo') }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
export default {
  components: { BaseDialog },
  data() {
    return {
      headerList: this.value,
      headerName: this.name,
    }
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    showDialog: {
      type: Boolean,
      default: false,
      required: true,
    },
    name: {
      type: String,
      required: false,
    },
  },
  methods: {
    setAll() {
      this.headerList.forEach((header) => {
        header.show = true
      })
      this.$emit('input', this.headerList)
      this.saveHeader()
    },
    handleInput() {
      this.$emit('input', this.headerList)
    },
    findAndClear(array) {
      array.forEach((value, index) => {
        if (value[value.length - 1] === this.headerName) array.splice(index, 1)
      })
      return array
    },
    saveHeader() {
      let headersControl = []
      if (localStorage.getItem('headersController'))
        headersControl = this.findAndClear(
          JSON.parse(localStorage.getItem('headersController'))
        )

      let headerArray = []
      this.headerList.forEach((header) => {
        if (header.show) headerArray.push(header.text)
      })

      headerArray.push(this.headerName)
      headersControl.push(headerArray)

      localStorage.setItem('headersController', JSON.stringify(headersControl))

      this.$emit('close')
    },
  },
}
</script>

<style></style>
